import Vue from "vue";
import VueRouter from "vue-router";
import api from "../services/api";
import routes from "./routes";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const isUserRoute = to.meta.isUserRoute;
  const isAdminRoute = to.meta.isAdminRoute;
  const isAuthRoute = to.meta.isAuthRoute;
  const isJuradoRoute = to.meta.isJuradoRoute;

  const loggedIn =
    localStorage.getItem("token@mf") && localStorage.getItem("user@mf");
  if (loggedIn) {
    try {
      const current = await api.get("/user/current");
      localStorage.setItem("user@mf", JSON.stringify(current.data));

      if (
        current.data.role == "ADMIN" &&
        current.data.details == "SYSTEM_ADMIN"
      ) {
        // admin
        if (isUserRoute || isAuthRoute || isJuradoRoute) {
          return next("/admin");
        }
      } else if (current.data.role == "JURADO") {
        // jurado
        if (isUserRoute || isAuthRoute || isAdminRoute) {
          return next("/jurado/home");
        }
      } else {
        // user
        if (isAdminRoute || isAuthRoute || isJuradoRoute) {
          return next("/usuario");
        }
      }
    } catch (err) {
      localStorage.removeItem("token@mf");
      localStorage.removeItem("user@mf");
      return next("/");
    }
  } else {
    // not logged
    if (isJuradoRoute) {
      return next("/jurado");
    } else if (isAdminRoute || isUserRoute) {
      return next("/login");
    }
  }

  next();
});

export default router;
